export * from './IconPorosity';
